(function (angular, window) {
    'use strict';

    /**
     * Gets the list of Services that are attached to the service type.
     */
    window.THF.Angular.API
        .factory('QuoteEmailModel', ['$http', '$q', function ($http, $q) {
            var QuoteEmailModel = function () {

            };

            QuoteEmailModel.prototype = {
                send: function(payload) {
                    var deferred = $q.defer();
                    var url = '/api/v1/lqt/send-quote';
                    url += ''
                    var req = {
                        method: 'POST',
                        url: url,
                        data: payload
                    };
                    $http(req)
                        .success(function (data) {

                            deferred.resolve(data);
                        })
                        .error(function () {
                            deferred.reject({
                                result: false,
                                message: 'No response from server',
                                content: ''
                            });
                        });
                    return deferred.promise;
                }
            };

            return new QuoteEmailModel();
        }]);

})(angular, window);